import { CONFIG } from './config/index'

const apiV1 = `${CONFIG.API}/v1`
const apiCoreServiceV1 = `${CONFIG.CORE_SERVICE_API_HOST}/v1`
const apiNonEmcs= `${CONFIG.NON_EMCS_API_HOST}`

export const api = {
  nonemcs:{
    create: () => (`${apiV1}/nonemcs`),
    update: () => (`${apiV1}/nonemcs`),
    tracking: (query) => (`${apiV1}/nonemcs/tracking?${query}`),
    confirm: (query) => (`${apiV1}/nonemcs/confirm?${query}`),
    draft: (query) => (`${apiV1}/nonemcs/draft?${query}`),
    newTask: () => (`${apiV1}/nonemcs/new-task`),
  },
  newcc:{
    getCarLicenses: (query) => (`${apiV1}/newcc/get-car-licenses?${query}`),
  },
  objectStorage:{
    docs: (query) => (`${apiV1}/object-storage/docs?${query}`),
    uploads: (query) => (`${apiV1}/object-storage/uploads?${query}`),
    deleteDoc: () => (`${apiV1}/object-storage/delete-doc`),
  },
  email:{
    contactUs: () => (`${apiV1}/email/contact-us`),
  },
  coreService:{
    getTitles: (type) => (`${apiCoreServiceV1}/titles/${type}`),
  },
  nonemcsApi:{
    getGarages: (type) => (`${apiNonEmcs}/garages/${type}`),
  },
  requestDocuments:{
    getRequestDocuments: (query) => (`${apiV1}/request-documents/${query}`),
    getRequestDocumentsUpload: (tranId,query) => (`${apiV1}/request-documents/${tranId}/uploads${query}`),
    getRequestDocumentsSaveUploads: (tranId,query) => (`${apiV1}/request-documents/${tranId}/save-uploads${query}`),
    getRequestDocumentsSubmit: (tranId,query) => (`${apiV1}/request-documents/${tranId}${query}`),
  }
}